export default __webpack_public_path__ + "static/media/git.a0b8447e.svg";